import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { goBack } from "connected-react-router";
import PropTypes from "prop-types";
import { Form, Label } from "reactstrap";
import generateAction from "../../../../utils/action-helpers";
import { DETAIL } from "../../../../state/actions";
import TooltipButton from "../../../ui/tooltip-button";
import ClientTypeChooser from "./client-type-choose";
import ClientForm from "./client-form";
import BigAccounts from "./big-accounts-form";

const AddEditForm = ({
  currency,
  close,
  alwaysOn,
  sapCode,
  society: defaultSociety,
  division: defaultDivision,
  isEditing,
  index,
  editingObject,
  canEdit
}) => {
  const [fromValues, setFormValues] = useState({});
  const [submitActive, setSubmitActive] = useState(false);
  const [showError, setShowError] = useState(false);
  const [activeForm, setActiveForm] = useState(!editingObject.ceco ? "CLIENT" : "BIG_ACCOUNT");
  const dispatch = useDispatch();
  const cancel = alwaysOn ? () => dispatch(goBack()) : close;

  const submit = () => {
    if (submitActive) {
      dispatch(
        generateAction(isEditing ? DETAIL.EDIT_MANUAL : DETAIL.ADD_MANUAL, {
          paymentObject: { ...fromValues },
          index
        })
      );
      close();
      setShowError(false);
    } else {
      setShowError(true);
    }
  };
  return (
    <div className="detail-form sidebar-content">
      <div className="sidebar-header">
        <h5 className="sidebar-title">Gestión manual</h5>
        <button type="button" className="close" aria-label="Close" onClick={cancel}>
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="sidebar-body form-group-info">
        <Label>* Los campos con son obligatorios</Label>
        <Form>
          <ClientTypeChooser
            value={!editingObject.ceco}
            onClientTypeChange={newType => setActiveForm(newType)}
          />
          {activeForm === "CLIENT" ? (
            <ClientForm
              currency={currency}
              showError={showError}
              canEdit={!canEdit}
              isEditing={isEditing}
              editingObject={editingObject}
              sapCode={sapCode}
              society={defaultSociety}
              division={defaultDivision}
              isValidChange={newValue => setSubmitActive(newValue)}
              onValueChanged={newValues => setFormValues(newValues)}
            />
          ) : (
            <BigAccounts
              currency={currency}
              showError={showError}
              canEdit={!canEdit}
              isEditing={isEditing}
              editingObject={editingObject}
              sapCode={sapCode}
              society={defaultSociety}
              division={defaultDivision}
              isValidChange={newValue => setSubmitActive(newValue)}
              onValueChanged={newValues => {
                setFormValues(newValues);
              }}
            />
          )}
        </Form>
      </div>
      <div className="sidebar-footer">
        <TooltipButton
          buttonClassName="btn cp-btn cp-btn__medium"
          onClick={cancel}
          buttonText="Cancelar"
          tooltipText="Salir de la gestión manual"
        />
        <TooltipButton
          buttonClassName="btn cp-btn__cta cp-btn__medium"
          onClick={submit}
          type="submit"
          disabled={!canEdit}
          buttonText={isEditing ? "Modificar" : "Añadir"}
          tooltipText="Crear partida"
          isSubmit
        />
      </div>
    </div>
  );
};

AddEditForm.propTypes = {
  currency: PropTypes.string,
  close: PropTypes.func,
  alwaysOn: PropTypes.bool,
  sapCode: PropTypes.string,
  society: PropTypes.number,
  division: PropTypes.number,
  isEditing: PropTypes.bool,
  index: PropTypes.number,
  editingObject: PropTypes.shape({
    amount: PropTypes.number,
    customer: PropTypes.string,
    society: PropTypes.string,
    division: PropTypes.string,
    recArea: PropTypes.string,
    accountingKey: PropTypes.string,
    ceco: PropTypes.string
  }),
  canEdit: PropTypes.bool
};

AddEditForm.defaultProps = {
  currency: "EUR",
  close: () => {},
  alwaysOn: false,
  sapCode: "",
  society: -1,
  division: -1,
  isEditing: false,
  index: 0,
  editingObject: {},
  canEdit: true
};

export default AddEditForm;
